import React from 'react';

type WarningMessageProps = {
  className?: string;
  children: React.ReactNode;
};

const WarningMessage = ({className, children}: WarningMessageProps) => (
  <div className={`bg-dandelion text-tenne rounded-large p-3 ${className}`}>
    {children}
  </div>
);

export default WarningMessage;
